// @flow

import * as React from 'react';
import classNames from 'classnames';
import color from 'color';

import useSheet from '../../jss';

type Props = {
  kind?: 'success' | 'warning' | 'danger' | 'info',
  message: string | Array<string>,
  sheet: Object
};

const defaultProps = {
  kind: 'danger'
};

function FormValidationMessage({ kind, message, sheet: { classes } }: Props) {
  if (!message || (Array.isArray(message) && message.length === 0)) {
    return null;
  }

  return (
    <div className={classNames(classes.wrapper, classes[kind])}>
      {Array.isArray(message) ? (
        message.map(err => (
          <div key={err.key} className={classes.message}>
            {err.message || err.messages[0]}
          </div>
        ))
      ) : (
        <div className={classes.message}>{message}</div>
      )}
    </div>
  );
}

FormValidationMessage.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    wrapper: {
      alignItems: 'center',
      borderRadius: theme.borderRadius.default,
      display: 'flex',
      flexDirection: 'column',
      fontSize: theme.fontSize.small,
      justifyContent: 'center',
      marginTop: theme.spacing.small,
      marginBottom: theme.spacing.small,
      padding: theme.spacing.small,
      textAlign: 'center'
    },
    success: {
      color: theme.color.success,
      background: color(theme.color.success)
        .mix(color('white'), 0.9)
        .string()
    },
    warning: {
      color: theme.color.warning,
      background: color(theme.color.warning)
        .mix(color('white'), 0.9)
        .string()
    },
    danger: {
      color: theme.color.danger,
      background: color(theme.color.danger)
        .mix(color('white'), 0.9)
        .string()
    },
    info: {
      color: theme.color.info,
      background: color(theme.color.info)
        .mix(color('white'), 0.9)
        .string()
    }
  };
}

export default useSheet(applyStyles)(FormValidationMessage);
